import { z } from 'zod';

export const invoiceSchema = z.object({
  id: z.string().uuid(),
  paymentId: z.string().uuid(),
  number: z.string().min(1),
  pdfS3Key: z.string().nullable(),
  amountHtCents: z.number().int().nonnegative(),
  amountTtcCents: z.number().int().nonnegative(),
  issuedAt: z.string().datetime(),
});
export type Invoice = z.infer<typeof invoiceSchema>;

export const invoiceDownloadResponseSchema = z.object({
  url: z.string().url(),
});
export type InvoiceDownloadResponse = z.infer<
  typeof invoiceDownloadResponseSchema
>;
